var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("react-dom"));else if ("function" == typeof define && define.amd) define(["react", "react-dom"], t);else {
    var o = "object" == typeof exports ? t(require("react"), require("react-dom")) : t(e.react, e["react-dom"]);

    for (var n in o) {
      ("object" == typeof exports ? exports : e)[n] = o[n];
    }
  }
}(this, function (e, t) {
  return function (e) {
    var t = {};

    function o(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, o), a.l = !0, a.exports;
    }

    return o.m = e, o.c = t, o.d = function (e, t, n) {
      o.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        o.d(n, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return n;
    }, o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, "a", t), t;
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.p = "", o(o.s = 3);
  }([function (t, o) {
    t.exports = e;
  }, function (e, o) {
    e.exports = t;
  }, function (e, t, o) {}, function (e, t, o) {
    "use strict";

    o.r(t);
    var n = o(0),
        a = o.n(n),
        r = o(1);

    function c(e) {
      var t = e.children,
          o = e.replace,
          n = e.bodyClass,
          r = e.header,
          c = e.footer,
          u = e.onDragStart,
          l = e.onDragEnd,
          s = e.onClose,
          i = e.closeButton,
          d = e.closeButtonPosition;
      return o ? t : a.a.createElement("div", {
        className: "panel panel-default " + ("bottom" === d ? "additional-row" : "")
      }, a.a.createElement("div", {
        className: "panel-heading",
        onTouchStart: u,
        onMouseDown: u,
        onTouchEnd: l,
        onMouseUp: l
      }, r && a.a.createElement("h3", {
        className: "panel-title"
      }, r)), a.a.createElement("div", {
        className: n
      }, t), c && a.a.createElement("div", {
        className: "panel-footer"
      }, c), a.a.createElement("div", {
        className: "close",
        onClick: s,
        style: {
          position: "header" === d ? "absolute" : "static",
          margin: "bottom" === d ? "10px auto" : ""
        }
      }, i));
    }

    c.defaultProps = {
      closeButton: "×",
      closeButtonPosition: "header",
      replace: !1,
      draggable: !1
    };
    var u = c;
    o(2);

    function l(e) {
      var t = Math.random().toString();

      var _Object = Object(n.useState)(!1),
          _Object2 = _slicedToArray(_Object, 2),
          o = _Object2[0],
          c = _Object2[1],
          _Object3 = Object(n.useState)(null),
          _Object4 = _slicedToArray(_Object3, 2),
          l = _Object4[0],
          s = _Object4[1],
          _Object5 = Object(n.useState)(null),
          _Object6 = _slicedToArray(_Object5, 2),
          i = _Object6[0],
          d = _Object6[1],
          _Object7 = Object(n.useState)(0),
          _Object8 = _slicedToArray(_Object7, 2),
          f = _Object8[0],
          p = _Object8[1],
          _Object9 = Object(n.useState)(0),
          _Object10 = _slicedToArray(_Object9, 2),
          m = _Object10[0],
          b = _Object10[1],
          _Object11 = Object(n.useState)(0),
          _Object12 = _slicedToArray(_Object11, 2),
          g = _Object12[0],
          v = _Object12[1],
          _Object13 = Object(n.useState)(0),
          _Object14 = _slicedToArray(_Object13, 2),
          h = _Object14[0],
          y = _Object14[1],
          j = e.isOpen,
          E = e.onClose;

      Object(n.useEffect)(function () {
        return j && function (e) {
          e && (e.stopPropagation(), e.preventDefault());
          !function () {
            document.addEventListener("keydown", O), document.activeElement instanceof HTMLElement && document.activeElement.blur();
            document.body.classList.add("body-modal-fix");
          }();
        }(), function () {
          j && x();
        };
      }, [j]);
      var O = Object(n.useCallback)(function (e) {
        var o = document.querySelectorAll(".pure-modal");
        if (o.length && o[o.length - 1].classList.contains(t)) return !1;
        27 === e.keyCode && document.activeElement && x(e);
      }, []);
      if (!j) return null;

      function x(e) {
        e && (e.stopPropagation(), e.preventDefault()), E && E(e ? {
          isPassive: !0
        } : {
          isPassive: !1
        }), document.removeEventListener("keydown", O), document.body.classList.remove("body-modal-fix"), s(null), d(null), p(0), b(0), v(0), y(0);
      }

      function S(e) {
        return e instanceof TouchEvent && e.changedTouches.length > 0 ? {
          pageX: e.changedTouches[0].pageX,
          pageY: e.changedTouches[0].pageY
        } : e instanceof MouseEvent ? {
          pageX: e.pageX,
          pageY: e.pageY
        } : {
          pageX: 0,
          pageY: 0
        };
      }

      function T(e) {
        if (e instanceof TouchEvent && e.changedTouches && e.changedTouches.length > 1) return P();
        e.preventDefault();

        var _S = S(e),
            t = _S.pageX,
            o = _S.pageY;

        "number" == typeof l && "number" == typeof i && (p(t - l - g), b(o - i - h));
      }

      function P() {
        return c(!1);
      }

      var M = e.children,
          _e$replace = e.replace,
          D = _e$replace === void 0 ? !1 : _e$replace,
          w = e.className,
          B = e.header,
          C = e.footer,
          _e$scrollable = e.scrollable,
          N = _e$scrollable === void 0 ? !0 : _e$scrollable,
          _e$draggable = e.draggable,
          k = _e$draggable === void 0 ? !1 : _e$draggable,
          L = e.width,
          X = e.closeButton,
          Y = e.closeButtonPosition,
          _e$portal = e.portal,
          _ = _e$portal === void 0 ? !1 : _e$portal;

      var q = ["pure-modal-backdrop"],
          $ = ["pure-modal", t],
          A = ["panel-body"];
      w && ($ = $.concat(w)), N ? A = A.concat("scrollable") : (q = q.concat("scrollable"), $ = $.concat("auto-height")), k && (q = q.concat("backdrop-overflow-hidden"));
      var H = a.a.createElement("div", {
        className: q.join(" "),
        onMouseDown: function onMouseDown(e) {
          if (e) {
            if (!e.target.classList.contains("pure-modal-backdrop")) return;
            e.stopPropagation(), e.preventDefault();
          }

          x(e);
        },
        onTouchMove: o ? T : void 0,
        onMouseMove: o ? T : void 0
      }, a.a.createElement("div", {
        className: $.join(" "),
        style: {
          transform: "translate(".concat(f, "px, ").concat(m, "px)"),
          transition: "none",
          width: L
        }
      }, a.a.createElement(u, {
        replace: D,
        header: B,
        footer: C,
        onDragStart: k ? function (e) {
          if (e instanceof TouchEvent && e.changedTouches && e.changedTouches.length > 1) return;
          e.preventDefault();

          var _S2 = S(e),
              t = _S2.pageX,
              o = _S2.pageY,
              _e$currentTarget$getB = e.currentTarget.getBoundingClientRect(),
              n = _e$currentTarget$getB.top,
              a = _e$currentTarget$getB.left;

          c(!0), s("number" == typeof l ? l : a), d("number" == typeof i ? i : n), v(t - a), y(o - n);
        } : void 0,
        onDragEnd: k ? P : void 0,
        onClose: x,
        bodyClass: A.join(" "),
        closeButton: X,
        closeButtonPosition: Y
      }, M)));
      return _ ? Object(r.createPortal)(H, document.body) : H;
    }

    t.default = a.a.memo(l);
  }]);
});